import type { ReactNode } from 'react';

export const symbol_equal: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M210-290q-20.83 0-35.42-14.62Q160-319.24 160-340.12q0-20.88 14.58-35.38Q189.17-390 210-390h540q20.83 0 35.42 14.62Q800-360.76 800-339.88q0 20.88-14.58 35.38Q770.83-290 750-290H210Zm0-280q-20.83 0-35.42-14.62Q160-599.24 160-620.12q0-20.88 14.58-35.38Q189.17-670 210-670h540q20.83 0 35.42 14.62Q800-640.76 800-619.88q0 20.88-14.58 35.38Q770.83-570 750-570H210Z"
		/>
	</svg>
);
